import React from 'react';

const Loading = ({ message = "Loading...", size = "default" }) => {
  const sizeClasses = {
    small: "h-6 w-6",
    default: "h-8 w-8",
    large: "h-12 w-12"
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div
          className={`inline-block ${sizeClasses[size]} animate-spin rounded-full border-4 border-solid border-indigo-600 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite] mb-4`}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
        <div className="text-lg font-medium text-gray-700">
          {message}
        </div>
      </div>
    </div>
  );
};

export default Loading;
